module.exports = __webpack_public_path__ + "static/SpotOn-d0104c3d5785563660fe2d8b12edab6e.jpg";